import { IcStatusLosange } from '@assets/icons/24x24';
import { createListCollection, Field as ChakraField, Fieldset, HStack, Icon, Text } from '@chakra-ui/react';
import { CockpitFormLayout } from '@components/cockpit/layouts/CockpitFormLayout';
import ModifiedTag from '@components/common/form/ModifiedField';
import RequiredIndicator from '@components/ui/RequiredIndicator';
import { CustomSelect } from '@components/ui/select/Select';
import { getClearanceColor } from '@utils/data/notification.utils';
import { hasChanged, isInvalid } from '@utils/validation/validation.utils';
import { useFormikContext } from 'formik';
import { FormattedMessage, useIntl } from 'react-intl';

import { DroneClearanceEnum, PartialDrone } from '@/types/utm/drone.types';

export default function DroneHabilitationTab() {
  const { formatMessage } = useIntl();
  const { errors, touched, initialValues, values, setFieldValue } = useFormikContext<PartialDrone>();

  return (
    <CockpitFormLayout title="components.utm.drones.tab.habilitation.title">
      <Fieldset.Root invalid={Object.keys(errors).some((key) => touched[key as keyof typeof touched])}>
        <ChakraField.Root
          variant="cockpit"
          required
          invalid={isInvalid('strategicDrone.strategicClearance', touched, errors)}
        >
          <ChakraField.Label width="100%" height="20px">
            <FormattedMessage id="components.utm.drones.strategicClearance" />
            <RequiredIndicator />
            {hasChanged('strategicDrone.strategicClearance', initialValues, values) && <ModifiedTag />}
          </ChakraField.Label>
          <CustomSelect
            value={values.strategicDrone.strategicClearance}
            collection={createListCollection({
              items: Object.values(DroneClearanceEnum).map((clearance) => ({
                label: formatMessage({ id: `clearance.${clearance}` }),
                value: clearance,
              })),
            })}
            formatLabel={(option) => (
              <HStack gap={1.5}>
                <Icon as={IcStatusLosange} boxSize="24px" color={getClearanceColor(option.value)} />
                <Text width="100%">{option.label}</Text>
              </HStack>
            )}
            onChange={(value) => setFieldValue('strategicDrone.strategicClearance', value)}
          />
        </ChakraField.Root>
      </Fieldset.Root>
    </CockpitFormLayout>
  );
}
